// extracted by mini-css-extract-plugin
export default {"container":"namespaceDetail_container__4-I+6","content":"namespaceDetail_content__znj6J","input":"namespaceDetail_input__IB6Fz"};